import React from "react";
import PropTypes from "prop-types";
import LiveCasinoGame from "./game";

const LiveCasinoGamesWrapper = ({ games, openGame }) => (
    <div className={`l-game-contain`}>
        {games.map(game => <LiveCasinoGame key={game.id} game={game} openGame={openGame} />)}
    </div>
);

LiveCasinoGamesWrapper.propTypes = {
    games: PropTypes.array,
    openGame: PropTypes.func
};

export default LiveCasinoGamesWrapper;